/** Per-user local-storage flag: set once the user dismisses the settings-moved pointer for good. */
export const SETTINGS_NAV_GUIDE_SHOWN_KEY = 'settings_nav_guide_shown';

/** Gives the appbar time to mount before the popover looks for its anchor. */
export const SETTINGS_NAV_GUIDE_DELAY = 800;

/** The appbar item the pointer anchors to. */
export const SETTINGS_NAV_GUIDE_ANCHOR_ID = 'appbar-settings-item';
